// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-0N-","title":"styles_title__1lchB"};